import { healthDbSchema, type HealthDbType, type IHealthDbServiceProvider } from '#domain/healthDb';
import ApiClient from '#infra/config/api.client';

export class HealthDbServiceProvider implements IHealthDbServiceProvider {
  async getLastHealthDbRecord(): Promise<HealthDbType> {
    const response = await ApiClient.get('/healthdb');
    const { message, createdAt } = response.data;

    return healthDbSchema.parse({ message, createdAt: new Date(createdAt) });
  }
}
